// ==========================================
// CARD LIBRARY
//
// pool field:
//   undefined / omitted  = standard (all star packs)
//   'ash'                = Ash Packs only
//   'ad'                 = Ad Pack only
//   'battlepass'         = Battle Pass reward only, never rolled
//
// ashValue is derived from ASH_VALUES below — no need to store per card.
// ==========================================

export const ASH_VALUES = {
  Common:    5,
  Rare:      15,
  Epic:      40,
  Legendary: 100,
  Mythic:    300,
  Divine:    1000,
  Special:   5000,
};

export const CARD_LIBRARY = [

  // ============================================================
  // STANDARD POOL — available in all Star Packs
  // ============================================================

  // ── DIVINE ──────────────────────────────────────────────────
  { id: 'd1',  name: 'DIVINE LORD',          rarity: 'Divine', power: 10000, pool: 'standard' },
  { id: 'd2',  name: 'DIVINE INTERVENTION',  rarity: 'Divine', power: 9999, pool: 'standard' },
  { id: 'd3',  name: 'DIVINE PROTECTION',    rarity: 'Divine', power: 9998, pool: 'standard' },
  { id: 'd4',  name: 'DIVINE WRATH',         rarity: 'Divine', power: 9997, pool: 'standard' },
  { id: 'd5',  name: 'DIVINE BLESSING',      rarity: 'Divine', power: 9996, pool: 'standard' },
  { id: 'd6',  name: 'DIVINE JUDGMENT',      rarity: 'Divine', power: 9995, pool: 'standard' },
  { id: 'd7',  name: 'DIVINE FURY',          rarity: 'Divine', power: 9994, pool: 'standard' },
  { id: 'd8',  name: 'DIVINE SHIELD',        rarity: 'Divine', power: 9993, pool: 'standard' },
  { id: 'd9',  name: 'DIVINE LIGHTNING',     rarity: 'Divine', power: 9992, pool: 'standard' },
  { id: 'd10', name: 'GOD',                  rarity: 'Divine', power: 9991, pool: 'standard' },
  { id: 'd11', name: 'DIVINE HEALING',       rarity: 'Divine', power: 9990, pool: 'standard' },
  { id: 'd12', name: 'DIVINE STORM',         rarity: 'Divine', power: 9989, pool: 'standard' },
  { id: 'd13', name: 'DIVINE ECLIPSE',       rarity: 'Divine', power: 9988, pool: 'standard' },
  { id: 'd14', name: 'DIVINE RECKONING',     rarity: 'Divine', power: 9987, pool: 'standard' },
  { id: 'd15', name: 'DIVINE NOVA',          rarity: 'Divine', power: 9986, pool: 'standard' },
  { id: 'd16', name: 'DIVINE OBLIVION',      rarity: 'Divine', power: 9985, pool: 'standard' },
  { id: 'd17', name: 'DIVINE COLLAPSE',      rarity: 'Divine', power: 9984, pool: 'standard' },
  { id: 'd18', name: 'DIVINE PARADOX',       rarity: 'Divine', power: 9983, pool: 'standard' },
  { id: 'd19', name: 'DIVINE SOVEREIGN',     rarity: 'Divine', power: 9982, pool: 'standard' },
  { id: 'd20', name: 'THE ARCHITECT',        rarity: 'Divine', power: 9981, pool: 'standard' },

  // ── MYTHIC ──────────────────────────────────────────────────
  { id: 'm1',  name: 'The Creator',          rarity: 'Mythic', power: 999, pool: 'standard' },
  { id: 'm2',  name: 'Infinity Engine',      rarity: 'Mythic', power: 999, pool: 'standard' },
  { id: 'm3',  name: 'Eternal Guardian',     rarity: 'Mythic', power: 999, pool: 'standard' },
  { id: 'm4',  name: 'Cosmic Overlord',      rarity: 'Mythic', power: 999, pool: 'standard' },
  { id: 'm5',  name: 'Time Weaver',          rarity: 'Mythic', power: 999, pool: 'standard' },
  { id: 'm6',  name: 'Void Emperor',         rarity: 'Mythic', power: 999, pool: 'standard' },
  { id: 'm7',  name: 'Neon Overlord',        rarity: 'Mythic', power: 999, pool: 'standard' },
  { id: 'm8',  name: 'Cyber Overlord',       rarity: 'Mythic', power: 999, pool: 'standard' },
  { id: 'm9',  name: 'Pixel Overlord',       rarity: 'Mythic', power: 999, pool: 'standard' },
  { id: 'm10', name: 'Static Overlord',      rarity: 'Mythic', power: 999, pool: 'standard' },
  { id: 'm11', name: 'Data Overlord',        rarity: 'Mythic', power: 999, pool: 'standard' },
  { id: 'm12', name: 'Holo Overlord',        rarity: 'Mythic', power: 999, pool: 'standard' },
  { id: 'm13', name: 'Quantum Overlord',     rarity: 'Mythic', power: 999, pool: 'standard' },
  { id: 'm14', name: 'Eternal Overlord',     rarity: 'Mythic', power: 999, pool: 'standard' },
  { id: 'm15', name: 'Cosmic Guardian',      rarity: 'Mythic', power: 999, pool: 'standard' },
  { id: 'm16', name: 'Time Guardian',        rarity: 'Mythic', power: 999, pool: 'standard' },
  { id: 'm17', name: 'Void Guardian',        rarity: 'Mythic', power: 999, pool: 'standard' },
  { id: 'm18', name: 'Neon Guardian',        rarity: 'Mythic', power: 999, pool: 'standard' },
  { id: 'm19', name: 'Shadow Overlord',      rarity: 'Mythic', power: 999, pool: 'standard' },
  { id: 'm20', name: 'Crystal Guardian',     rarity: 'Mythic', power: 999, pool: 'standard' },
  { id: 'm21', name: 'Iron Titan',           rarity: 'Mythic', power: 999, pool: 'standard' },
  { id: 'm22', name: 'Plasma Overlord',      rarity: 'Mythic', power: 999, pool: 'standard' },
  { id: 'm23', name: 'Storm Weaver',         rarity: 'Mythic', power: 999, pool: 'standard' },
  { id: 'm25', name: 'Rift Colossus',        rarity: 'Mythic', power: 999, pool: 'standard' },
  { id: 'm26', name: 'Aether Emperor',       rarity: 'Mythic', power: 999, pool: 'standard' },
  { id: 'm27', name: 'Null Sovereign',       rarity: 'Mythic', power: 999, pool: 'standard' },
  { id: 'm28', name: 'Omega Warlord',        rarity: 'Mythic', power: 999, pool: 'standard' },
  { id: 'm29', name: 'Fractal Titan',        rarity: 'Mythic', power: 999, pool: 'standard' },
  { id: 'm30', name: 'Binary God',           rarity: 'Mythic', power: 999, pool: 'standard' },

  // ── LEGENDARY ───────────────────────────────────────────────
  { id: 'l1',  name: 'Neon Dragon',          rarity: 'Legendary', power: 920, pool: 'standard' },
  { id: 'l2',  name: 'Quantum Knight',       rarity: 'Legendary', power: 750, pool: 'standard' },
  { id: 'l3',  name: 'Quantum Paladin',      rarity: 'Legendary', power: 800, pool: 'standard' },
  { id: 'l4',  name: 'Void Assassin',        rarity: 'Legendary', power: 850, pool: 'standard' },
  { id: 'l5',  name: 'Neon Archer',          rarity: 'Legendary', power: 750, pool: 'standard' },
  { id: 'l6',  name: 'Cyber Sorcerer',       rarity: 'Legendary', power: 700, pool: 'standard' },
  { id: 'l7',  name: 'Pixel Mage',           rarity: 'Legendary', power: 700, pool: 'standard' },
  { id: 'l8',  name: 'Static Knight',        rarity: 'Legendary', power: 900, pool: 'standard' },
  { id: 'l9',  name: 'Data Archer',          rarity: 'Legendary', power: 850, pool: 'standard' },
  { id: 'l10', name: 'Holo Mage',            rarity: 'Legendary', power: 800, pool: 'standard' },
  { id: 'l11', name: 'Cyber Knight',         rarity: 'Legendary', power: 800, pool: 'standard' },
  { id: 'l12', name: 'Static Sorcerer',      rarity: 'Legendary', power: 750, pool: 'standard' },
  { id: 'l13', name: 'Data Knight',          rarity: 'Legendary', power: 700, pool: 'standard' },
  { id: 'l14', name: 'Neon Mage',            rarity: 'Legendary', power: 900, pool: 'standard' },
  { id: 'l15', name: 'Void Knight',          rarity: 'Legendary', power: 850, pool: 'standard' },
  { id: 'l16', name: 'Pixel Archer',         rarity: 'Legendary', power: 800, pool: 'standard' },
  { id: 'l17', name: 'Cyber Mage',           rarity: 'Legendary', power: 750, pool: 'standard' },
  { id: 'l18', name: 'Static Archer',        rarity: 'Legendary', power: 700, pool: 'standard' },
  { id: 'l19', name: 'Data Sorcerer',        rarity: 'Legendary', power: 700, pool: 'standard' },
  { id: 'l20', name: 'Holo Knight',          rarity: 'Legendary', power: 750, pool: 'standard' },
  { id: 'l21', name: 'Neon Duke',            rarity: 'Legendary', power: 800, pool: 'standard' },
  { id: 'l22', name: 'Void Duke',            rarity: 'Legendary', power: 750, pool: 'standard' },
  { id: 'l23', name: 'Cyber Duke',           rarity: 'Legendary', power: 700, pool: 'standard' },
  { id: 'l24', name: 'Pixel Duke',           rarity: 'Legendary', power: 700, pool: 'standard' },
  { id: 'l25', name: 'Static Duke',          rarity: 'Legendary', power: 750, pool: 'standard' },
  { id: 'l26', name: 'Data Duke',            rarity: 'Legendary', power: 800, pool: 'standard' },
  { id: 'l27', name: 'Holo Duke',            rarity: 'Legendary', power: 850, pool: 'standard' },
  { id: 'l28', name: 'Quantum Samurai',      rarity: 'Legendary', power: 900, pool: 'standard' },
  { id: 'l29', name: 'Data Samurai',         rarity: 'Legendary', power: 850, pool: 'standard' },
  { id: 'l30', name: 'Holo Samurai',         rarity: 'Legendary', power: 800, pool: 'standard' },
  { id: 'l31', name: 'Cyber Samurai',        rarity: 'Legendary', power: 750, pool: 'standard' },
  { id: 'l32', name: 'Pixel Samurai',        rarity: 'Legendary', power: 700, pool: 'standard' },
  { id: 'l33', name: 'Static Samurai',       rarity: 'Legendary', power: 700, pool: 'standard' },
  { id: 'l34', name: 'Neon Samurai',         rarity: 'Legendary', power: 750, pool: 'standard' },
  { id: 'l35', name: 'Void Samurai',         rarity: 'Legendary', power: 800, pool: 'standard' },
  { id: 'l36', name: 'Spectral Warlord',     rarity: 'Legendary', power: 920, pool: 'standard' },
  { id: 'l37', name: 'Iron Phoenix',         rarity: 'Legendary', power: 880, pool: 'standard' },
  { id: 'l38', name: 'Chrome Dragon',        rarity: 'Legendary', power: 860, pool: 'standard' },
  { id: 'l39', name: 'Plasma Duke',          rarity: 'Legendary', power: 840, pool: 'standard' },
  { id: 'l40', name: 'Crystal Samurai',      rarity: 'Legendary', power: 820, pool: 'standard' },
  { id: 'l41', name: 'Shadow Paladin',       rarity: 'Legendary', power: 800, pool: 'standard' },
  { id: 'l42', name: 'Storm Drake',          rarity: 'Legendary', power: 870, pool: 'standard' },
  { id: 'l43', name: 'Rift Walker',          rarity: 'Legendary', power: 910, pool: 'standard' },
  { id: 'l44', name: 'Null Archer',          rarity: 'Legendary', power: 890, pool: 'standard' },
  { id: 'l45', name: 'Binary Blade',         rarity: 'Legendary', power: 880, pool: 'standard' },
  { id: 'l46', name: 'Fractal Knight',       rarity: 'Legendary', power: 860, pool: 'standard' },
  { id: 'l47', name: 'Aether Sorcerer',      rarity: 'Legendary', power: 840, pool: 'standard' },
  { id: 'l48', name: 'Pulse Warden',         rarity: 'Legendary', power: 820, pool: 'standard' },
  { id: 'l49', name: 'Omega Ranger',         rarity: 'Legendary', power: 800, pool: 'standard' },
  { id: 'l50', name: 'Surge Paladin',        rarity: 'Legendary', power: 770, pool: 'standard' },
  { id: 'l51', name: 'Void Phantom',         rarity: 'Legendary', power: 930, pool: 'standard' },
  { id: 'l52', name: 'Neon Specter',         rarity: 'Legendary', power: 910, pool: 'standard' },
  { id: 'l53', name: 'Cyber Titan',          rarity: 'Legendary', power: 890, pool: 'standard' },
  { id: 'l54', name: 'Data Phantom',         rarity: 'Legendary', power: 870, pool: 'standard' },
  { id: 'l55', name: 'Pixel Specter',        rarity: 'Legendary', power: 850, pool: 'standard' },
  { id: 'l56', name: 'Static Revenant',      rarity: 'Legendary', power: 830, pool: 'standard' },
  { id: 'l57', name: 'Quantum Specter',      rarity: 'Legendary', power: 810, pool: 'standard' },
  { id: 'l58', name: 'Holo Revenant',        rarity: 'Legendary', power: 790, pool: 'standard' },
  { id: 'l59', name: 'Neon Revenant',        rarity: 'Legendary', power: 780, pool: 'standard' },
  { id: 'l60', name: 'Void Revenant',        rarity: 'Legendary', power: 760, pool: 'standard' },

  // ── EPIC ─────────────────────────────────────────────────────
  { id: 'e1',  name: 'Void Reaver',          rarity: 'Epic', power: 95, pool: 'standard' },
  { id: 'e2',  name: 'Holo Assassin',        rarity: 'Epic', power: 88, pool: 'standard' },
  { id: 'e3',  name: 'Data Wraith',          rarity: 'Epic', power: 92, pool: 'standard' },
  { id: 'e4',  name: 'Pixel Ninja',          rarity: 'Epic', power: 82, pool: 'standard' },
  { id: 'e5',  name: 'Neon Priestess',       rarity: 'Epic', power: 80, pool: 'standard' },
  { id: 'e6',  name: 'Static Mage',          rarity: 'Epic', power: 90, pool: 'standard' },
  { id: 'e7',  name: 'Holo Knight Prime',          rarity: 'Epic', power: 85, pool: 'standard' },
  { id: 'e8',  name: 'Cyber Archer',         rarity: 'Epic', power: 80, pool: 'standard' },
  { id: 'e9',  name: 'Cyber Mage Prime',           rarity: 'Epic', power: 78, pool: 'standard' },
  { id: 'e10', name: 'Cyber Knight Prime',         rarity: 'Epic', power: 78, pool: 'standard' },
  { id: 'e11', name: 'Static Archer Prime',        rarity: 'Epic', power: 80, pool: 'standard' },
  { id: 'e12', name: 'Static Sorcerer Prime',      rarity: 'Epic', power: 80, pool: 'standard' },
  { id: 'e13', name: 'Data Archer Prime',          rarity: 'Epic', power: 78, pool: 'standard' },
  { id: 'e14', name: 'Holo Mage Prime',            rarity: 'Epic', power: 80, pool: 'standard' },
  { id: 'e15', name: 'Holo Archer',          rarity: 'Epic', power: 80, pool: 'standard' },
  { id: 'e16', name: 'Neon Mage Prime',            rarity: 'Epic', power: 78, pool: 'standard' },
  { id: 'e17', name: 'Neon Archer Prime',          rarity: 'Epic', power: 78, pool: 'standard' },
  { id: 'e18', name: 'Void Mage Prime',            rarity: 'Epic', power: 80, pool: 'standard' },
  { id: 'e19', name: 'Void Assassin Prime',        rarity: 'Epic', power: 80, pool: 'standard' },
  { id: 'e20', name: 'Pixel Assassin',       rarity: 'Epic', power: 78, pool: 'standard' },
  { id: 'e21', name: 'Pixel Knight Prime',         rarity: 'Epic', power: 78, pool: 'standard' },
  { id: 'e22', name: 'Cyber Assassin',       rarity: 'Epic', power: 80, pool: 'standard' },
  { id: 'e23', name: 'Cyber Sorcerer Prime',       rarity: 'Epic', power: 80, pool: 'standard' },
  { id: 'e24', name: 'Quantum Warlord',      rarity: 'Epic', power: 96, pool: 'standard' },
  { id: 'e25', name: 'Neon Paladin',         rarity: 'Epic', power: 94, pool: 'standard' },
  { id: 'e26', name: 'Data Champion',        rarity: 'Epic', power: 92, pool: 'standard' },
  { id: 'e27', name: 'Static Berserker',     rarity: 'Epic', power: 90, pool: 'standard' },
  { id: 'e28', name: 'Holo Champion',        rarity: 'Epic', power: 88, pool: 'standard' },
  { id: 'e29', name: 'Iron Rogue',           rarity: 'Epic', power: 86, pool: 'standard' },
  { id: 'e30', name: 'Plasma Hunter',        rarity: 'Epic', power: 84, pool: 'standard' },
  { id: 'e31', name: 'Rift Stalker',         rarity: 'Epic', power: 97, pool: 'standard' },
  { id: 'e32', name: 'Fractal Mage',         rarity: 'Epic', power: 95, pool: 'standard' },
  { id: 'e33', name: 'Aether Knight',        rarity: 'Epic', power: 93, pool: 'standard' },
  { id: 'e34', name: 'Null Hunter',          rarity: 'Epic', power: 91, pool: 'standard' },
  { id: 'e35', name: 'Binary Sorcerer',      rarity: 'Epic', power: 89, pool: 'standard' },
  { id: 'e36', name: 'Surge Warrior',        rarity: 'Epic', power: 87, pool: 'standard' },
  { id: 'e37', name: 'Pulse Assassin',       rarity: 'Epic', power: 85, pool: 'standard' },
  { id: 'e38', name: 'Omega Scout',          rarity: 'Epic', power: 83, pool: 'standard' },
  { id: 'e39', name: 'Neon Revenant Prime',        rarity: 'Epic', power: 81, pool: 'standard' },
  { id: 'e40', name: 'Void Specter',         rarity: 'Epic', power: 79, pool: 'standard' },
  { id: 'e41', name: 'Data Phantom Prime',         rarity: 'Epic', power: 77, pool: 'standard' },
  { id: 'e42', name: 'Static Specter',       rarity: 'Epic', power: 76, pool: 'standard' },
  { id: 'e43', name: 'Cyber Phantom',        rarity: 'Epic', power: 75, pool: 'standard' },

  // ── RARE ─────────────────────────────────────────────────────
  { id: 'r1',  name: 'Cyber Wolf',           rarity: 'Rare', power: 70, pool: 'standard' },
  { id: 'r2',  name: 'Pixel Sorcerer',       rarity: 'Rare', power: 65, pool: 'standard' },
  { id: 'r3',  name: 'Neon Samurai MK-II',         rarity: 'Rare', power: 75, pool: 'standard' },
  { id: 'r4',  name: 'Void Berserker MK-II',       rarity: 'Rare', power: 68, pool: 'standard' },
  { id: 'r5',  name: 'Holo Ranger',          rarity: 'Rare', power: 72, pool: 'standard' },
  { id: 'r6',  name: 'Quantum Sorcerer',     rarity: 'Rare', power: 73, pool: 'standard' },
  { id: 'r7',  name: 'Static Ninja',         rarity: 'Rare', power: 65, pool: 'standard' },
  { id: 'r8',  name: 'Neon Archer MK-II',          rarity: 'Rare', power: 64, pool: 'standard' },
  { id: 'r9',  name: 'Cyber Priestess',      rarity: 'Rare', power: 63, pool: 'standard' },
  { id: 'r10', name: 'Holo Knight MK-II',          rarity: 'Rare', power: 62, pool: 'standard' },
  { id: 'r11', name: 'Data Sorcerer MK-II',        rarity: 'Rare', power: 60, pool: 'standard' },
  { id: 'r12', name: 'Void Archer',          rarity: 'Rare', power: 58, pool: 'standard' },
  { id: 'r13', name: 'Pixel Knight MK-II',         rarity: 'Rare', power: 55, pool: 'standard' },
  { id: 'r14', name: 'Static Mage MK-II',          rarity: 'Rare', power: 55, pool: 'standard' },
  { id: 'r15', name: 'Neon Sorcerer',        rarity: 'Rare', power: 55, pool: 'standard' },
  { id: 'r16', name: 'Cyber Archer MK-II',         rarity: 'Rare', power: 55, pool: 'standard' },
  { id: 'r17', name: 'Holo Mage MK-II',            rarity: 'Rare', power: 55, pool: 'standard' },
  { id: 'r18', name: 'Cyber Knight MK-II',         rarity: 'Rare', power: 55, pool: 'standard' },
  { id: 'r19', name: 'Static Sorcerer MK-II',      rarity: 'Rare', power: 55, pool: 'standard' },
  { id: 'r20', name: 'Data Archer MK-II',          rarity: 'Rare', power: 55, pool: 'standard' },
  { id: 'r21', name: 'Neon Knight',          rarity: 'Rare', power: 55, pool: 'standard' },
  { id: 'r22', name: 'Void Mage MK-II',            rarity: 'Rare', power: 55, pool: 'standard' },
  { id: 'r23', name: 'Pixel Warlock',        rarity: 'Rare', power: 55, pool: 'standard' },
  { id: 'r24', name: 'Cyber Mage MK-II',           rarity: 'Rare', power: 55, pool: 'standard' },
  { id: 'r25', name: 'Neon Mage MK-II',            rarity: 'Rare', power: 55, pool: 'standard' },
  { id: 'r26', name: 'Void Knight MK-II',          rarity: 'Rare', power: 55, pool: 'standard' },
  { id: 'r27', name: 'Pixel Archer MK-II',         rarity: 'Rare', power: 55, pool: 'standard' },
  { id: 'r28', name: 'Cyber Sorcerer MK-II',       rarity: 'Rare', power: 55, pool: 'standard' },
  { id: 'r29', name: 'Static Archer MK-II',        rarity: 'Rare', power: 55, pool: 'standard' },
  { id: 'r30', name: 'Data Knight MK-II',          rarity: 'Rare', power: 55, pool: 'standard' },
  { id: 'r31', name: 'Holo Sorcerer',        rarity: 'Rare', power: 55, pool: 'standard' },
  { id: 'r32', name: 'Quantum Assassin',     rarity: 'Rare', power: 76, pool: 'standard' },
  { id: 'r33', name: 'Data Warrior',         rarity: 'Rare', power: 74, pool: 'standard' },
  { id: 'r34', name: 'Static Ranger',        rarity: 'Rare', power: 71, pool: 'standard' },
  { id: 'r35', name: 'Void Wizard',          rarity: 'Rare', power: 69, pool: 'standard' },
  { id: 'r36', name: 'Holo Warrior',         rarity: 'Rare', power: 67, pool: 'standard' },
  { id: 'r37', name: 'Cyber Ranger',         rarity: 'Rare', power:66, pool:'standard' },
  { id: 'r38', name: 'Iron Scout',           rarity: 'Rare', power: 62, pool: 'standard' },
  { id: 'r39', name: 'Rift Rogue',           rarity: 'Rare', power: 77, pool: 'standard' },
  { id: 'r40', name: 'Fractal Archer',       rarity: 'Rare', power: 76, pool: 'standard' },
  { id: 'r41', name: 'Aether Scout',         rarity: 'Rare', power: 75, pool: 'standard' },
  { id: 'r42', name: 'Null Warrior',         rarity: 'Rare', power: 74, pool: 'standard' },
  { id: 'r43', name: 'Binary Ranger',        rarity: 'Rare', power: 73, pool: 'standard' },
  { id: 'r44', name: 'Surge Scout',          rarity: 'Rare', power: 72, pool: 'standard' },
  { id: 'r45', name: 'Pulse Ranger',         rarity: 'Rare', power: 71, pool: 'standard' },
  { id: 'r46', name: 'Omega Warrior',        rarity: 'Rare', power: 70, pool: 'standard' },
  { id: 'r47', name: 'Neon Shaman',          rarity: 'Rare', power: 68, pool: 'standard' },
  { id: 'r48', name: 'Data Shaman',          rarity: 'Rare', power: 66, pool: 'standard' },
  { id: 'r49', name: 'Pixel Wraith',         rarity: 'Rare', power: 64, pool: 'standard' },
  { id: 'r50', name: 'Holo Wraith',          rarity: 'Rare', power: 62, pool: 'standard' },

  // ── COMMON ───────────────────────────────────────────────────
  { id: 'c1',  name: 'Data Ghost',           rarity: 'Common', power: 30, pool: 'standard' },
  { id: 'c2',  name: 'Static Golem',         rarity: 'Common', power: 45, pool: 'standard' },
  { id: 'c3',  name: 'Cyber Shaman',         rarity: 'Common', power: 40, pool: 'standard' },
  { id: 'c4',  name: 'Static Archer Grunt',        rarity: 'Common', power: 35, pool: 'standard' },
  { id: 'c5',  name: 'Cyber Berserker',      rarity: 'Common', power: 50, pool: 'standard' },
  { id: 'c6',  name: 'Pixel Warrior',        rarity: 'Common', power: 42, pool: 'standard' },
  { id: 'c7',  name: 'Neon Scout',           rarity: 'Common', power: 25, pool: 'standard' },
  { id: 'c8',  name: 'Void Sentry',          rarity: 'Common', power: 20, pool: 'standard' },
  { id: 'c9',  name: 'Holo Sentry',          rarity: 'Common', power: 15, pool: 'standard' },
  { id: 'c10', name: 'Pixel Sentry',         rarity: 'Common', power: 10, pool: 'standard' },
  { id: 'c11', name: 'Cyber Sentry',         rarity: 'Common', power: 10, pool: 'standard' },
  { id: 'c12', name: 'Static Sentry',        rarity: 'Common', power: 10, pool: 'standard' },
  { id: 'c13', name: 'Data Sentry',          rarity: 'Common', power: 10, pool: 'standard' },
  { id: 'c14', name: 'Neon Sentry',          rarity: 'Common', power: 5,  pool: 'standard' },
  { id: 'c15', name: 'Void Scout',           rarity: 'Common', power: 50, pool: 'standard' },
  { id: 'c16', name: 'Holo Scout',           rarity: 'Common', power: 45, pool: 'standard' },
  { id: 'c17', name: 'Pixel Scout',          rarity: 'Common', power: 40, pool: 'standard' },
  { id: 'c18', name: 'Cyber Scout',          rarity: 'Common', power: 35, pool: 'standard' },
  { id: 'c19', name: 'Static Scout',         rarity: 'Common', power: 30, pool: 'standard' },
  { id: 'c20', name: 'Data Scout',           rarity: 'Common', power: 25, pool: 'standard' },
  { id: 'c21', name: 'Neon Berserker',       rarity: 'Common', power: 20, pool: 'standard' },
  { id: 'c22', name: 'Void Berserker',       rarity: 'Common', power: 30, pool: 'standard' },
  { id: 'c23', name: 'Quantum Sentry',       rarity: 'Common', power: 48, pool: 'standard' },
  { id: 'c24', name: 'Neon Wraith',          rarity: 'Common', power: 38, pool: 'standard' },
  { id: 'c25', name: 'Data Berserker',       rarity: 'Common', power: 32, pool: 'standard' },
  { id: 'c26', name: 'Void Shaman',          rarity: 'Common', power: 28, pool: 'standard' },
  { id: 'c27', name: 'Cyber Phantom MK-II',        rarity: 'Common', power: 22, pool: 'standard' },
  { id: 'c28', name: 'Rift Sentry',          rarity: 'Common', power: 48, pool: 'standard' },
  { id: 'c29', name: 'Fractal Wisp',         rarity: 'Common', power: 44, pool: 'standard' },
  { id: 'c30', name: 'Binary Sentry',        rarity: 'Common', power: 42, pool: 'standard' },
  { id: 'c31', name: 'Surge Wisp',           rarity: 'Common', power: 38, pool: 'standard' },
  { id: 'c32', name: 'Pulse Sentry',         rarity: 'Common', power: 34, pool: 'standard' },
  { id: 'c33', name: 'Null Wisp',            rarity: 'Common', power: 30, pool: 'standard' },
  { id: 'c34', name: 'Aether Sentry',        rarity: 'Common', power: 26, pool: 'standard' },
  { id: 'c35', name: 'Omega Wisp',           rarity: 'Common', power: 18, pool: 'standard' },
  { id: 'c36', name: 'Static Wraith',        rarity: 'Common', power: 14, pool: 'standard' },
  { id: 'c37', name: 'Holo Phantom',         rarity: 'Common', power: 12, pool: 'standard' },
  { id: 'c38', name: 'Neon Wisp',            rarity: 'Common', power: 8,  pool: 'standard' },
  { id: 'c39', name: 'Pixel Phantom',        rarity: 'Common', power: 6,  pool: 'standard' },
  { id: 'c40', name: 'Data Wisp',            rarity: 'Common', power: 5,  pool: 'standard' },

  // ============================================================
  // ASH POOL — available in Ash Packs only
  // ============================================================

  // ── DIVINE ──
  { id: 'a_d1', name: 'EMBER DEITY',         rarity: 'Divine',    power: 9985, pool: 'ash' },
  { id: 'a_d2', name: 'CINDER GOD',          rarity: 'Divine',    power: 9980, pool: 'ash' },
  { id: 'a_d3', name: 'INFERNO SOVEREIGN',   rarity: 'Divine',    power: 9975, pool: 'ash' },
  { id: 'a_d4', name: 'FORGE ETERNAL',       rarity: 'Divine',    power: 9970, pool: 'ash' },

  // ── MYTHIC ──
  { id: 'a_m1', name: 'Forge Titan',         rarity: 'Mythic',    power: 999,  pool: 'ash' },
  { id: 'a_m2', name: 'Ash Phoenix',         rarity: 'Mythic',    power: 999,  pool: 'ash' },
  { id: 'a_m3', name: 'Ember Warlord',       rarity: 'Mythic',    power: 999,  pool: 'ash' },
  { id: 'a_m4', name: 'Cinder Sovereign',    rarity: 'Mythic',    power: 999,  pool: 'ash' },
  { id: 'a_m5', name: 'Smelt Emperor',       rarity: 'Mythic',    power: 999,  pool: 'ash' },
  { id: 'a_m6', name: 'Scorch Overlord',     rarity: 'Mythic',    power: 999,  pool: 'ash' },

  // ── LEGENDARY ──
  { id: 'a_l1',  name: 'Cinder Knight',      rarity: 'Legendary', power: 940,  pool: 'ash' },
  { id: 'a_l2',  name: 'Forge Samurai',      rarity: 'Legendary', power: 930,  pool: 'ash' },
  { id: 'a_l3',  name: 'Ash Dragon',         rarity: 'Legendary', power: 920,  pool: 'ash' },
  { id: 'a_l4',  name: 'Ember Duke',         rarity: 'Legendary', power: 910,  pool: 'ash' },
  { id: 'a_l5',  name: 'Smelt Guardian',     rarity: 'Legendary', power: 900,  pool: 'ash' },
  { id: 'a_l6',  name: 'Scorch Paladin',     rarity: 'Legendary', power: 890,  pool: 'ash' },
  { id: 'a_l7',  name: 'Char Assassin',      rarity: 'Legendary', power: 870,  pool: 'ash' },
  { id: 'a_l8',  name: 'Molten Warlord',     rarity: 'Legendary', power: 850,  pool: 'ash' },
  { id: 'a_l9',  name: 'Pyro Specter',       rarity: 'Legendary', power: 840,  pool: 'ash' },
  { id: 'a_l10', name: 'Blaze Revenant',     rarity: 'Legendary', power: 820,  pool: 'ash' },

  // ── EPIC ──
  { id: 'a_e1',  name: 'Forge Warrior',      rarity: 'Epic',      power: 97,   pool: 'ash' },
  { id: 'a_e2',  name: 'Ash Hunter',         rarity: 'Epic',      power: 95,   pool: 'ash' },
  { id: 'a_e3',  name: 'Ember Sorcerer',     rarity: 'Epic',      power: 93,   pool: 'ash' },
  { id: 'a_e4',  name: 'Cinder Scout',       rarity: 'Epic',      power: 91,   pool: 'ash' },
  { id: 'a_e5',  name: 'Smelt Mage',         rarity: 'Epic',      power: 89,   pool: 'ash' },
  { id: 'a_e6',  name: 'Scorch Knight',      rarity: 'Epic',      power: 87,   pool: 'ash' },
  { id: 'a_e7',  name: 'Char Ranger',        rarity: 'Epic',      power: 85,   pool: 'ash' },
  { id: 'a_e8',  name: 'Molten Assassin',    rarity: 'Epic',      power: 83,   pool: 'ash' },
  { id: 'a_e9',  name: 'Pyro Archer',        rarity: 'Epic',      power: 81,   pool: 'ash' },
  { id: 'a_e10', name: 'Blaze Paladin',      rarity: 'Epic',      power: 79,   pool: 'ash' },

  // ── RARE ──
  { id: 'a_r1',  name: 'Ember Archer',       rarity: 'Rare',      power: 77,   pool: 'ash' },
  { id: 'a_r2',  name: 'Forge Scout',        rarity: 'Rare',      power: 76,   pool: 'ash' },
  { id: 'a_r3',  name: 'Ash Ranger',         rarity: 'Rare',      power: 75,   pool: 'ash' },
  { id: 'a_r4',  name: 'Cinder Rogue',       rarity: 'Rare',      power: 74,   pool: 'ash' },
  { id: 'a_r5',  name: 'Smelt Knight',       rarity: 'Rare',      power: 73,   pool: 'ash' },
  { id: 'a_r6',  name: 'Scorch Warrior',     rarity: 'Rare',      power: 72,   pool: 'ash' },
  { id: 'a_r7',  name: 'Char Mage',          rarity: 'Rare',      power: 71,   pool: 'ash' },
  { id: 'a_r8',  name: 'Molten Scout',       rarity: 'Rare',      power: 70,   pool: 'ash' },
  { id: 'a_r9',  name: 'Pyro Sorcerer',      rarity: 'Rare',      power: 68,   pool: 'ash' },
  { id: 'a_r10', name: 'Blaze Ranger',       rarity: 'Rare',      power: 66,   pool: 'ash' },

  // ============================================================
  // AD POOL — Ad Packs (watch an ad) only
  // ============================================================

  // ── DIVINE ──
  { id: 'ad_d1', name: 'SPECTRAL DEITY',     rarity: 'Divine',    power: 9978, pool: 'ad' },
  { id: 'ad_d2', name: 'RADIANT SOVEREIGN',  rarity: 'Divine',    power: 9973, pool: 'ad' },

  // ── MYTHIC ──
  { id: 'ad_m1', name: 'Prism Overlord',     rarity: 'Mythic',    power: 999,  pool: 'ad' },
  { id: 'ad_m2', name: 'Radiant Guardian',   rarity: 'Mythic',    power: 999,  pool: 'ad' },
  { id: 'ad_m3', name: 'Echo Sovereign',     rarity: 'Mythic',    power: 999,  pool: 'ad' },
  { id: 'ad_m4', name: 'Lumen Emperor',      rarity: 'Mythic',    power: 999,  pool: 'ad' },

  // ── LEGENDARY ──
  { id: 'ad_l1', name: 'Echo Knight',        rarity: 'Legendary', power: 935,  pool: 'ad' },
  { id: 'ad_l2', name: 'Spectral Dragon',    rarity: 'Legendary', power: 920,  pool: 'ad' },
  { id: 'ad_l3', name: 'Prism Samurai',      rarity: 'Legendary', power: 905,  pool: 'ad' },
  { id: 'ad_l4', name: 'Radiant Paladin',    rarity: 'Legendary', power: 890,  pool: 'ad' },
  { id: 'ad_l5', name: 'Lumen Warlord',      rarity: 'Legendary', power: 875,  pool: 'ad' },
  { id: 'ad_l6', name: 'Signal Duke',        rarity: 'Legendary', power: 860,  pool: 'ad' },
  { id: 'ad_l7', name: 'Prism Revenant',     rarity: 'Legendary', power: 845,  pool: 'ad' },
  { id: 'ad_l8', name: 'Echo Specter',       rarity: 'Legendary', power: 830,  pool: 'ad' },

  // ── EPIC ──
  { id: 'ad_e1', name: 'Radiant Hunter',     rarity: 'Epic',      power: 97,   pool: 'ad' },
  { id: 'ad_e2', name: 'Echo Sorcerer',      rarity: 'Epic',      power: 95,   pool: 'ad' },
  { id: 'ad_e3', name: 'Prism Warrior',      rarity: 'Epic',      power: 93,   pool: 'ad' },
  { id: 'ad_e4', name: 'Lumen Scout',        rarity: 'Epic',      power: 91,   pool: 'ad' },
  { id: 'ad_e5', name: 'Signal Assassin',    rarity: 'Epic',      power: 89,   pool: 'ad' },
  { id: 'ad_e6', name: 'Prism Archer',       rarity: 'Epic',      power: 87,   pool: 'ad' },
  { id: 'ad_e7', name: 'Echo Ranger',        rarity: 'Epic',      power: 85,   pool: 'ad' },

  // ── RARE ──
  { id: 'ad_r1', name: 'Spectral Scout',     rarity: 'Rare',      power: 77,   pool: 'ad' },
  { id: 'ad_r2', name: 'Radiant Archer',     rarity: 'Rare',      power: 75,   pool: 'ad' },
  { id: 'ad_r3', name: 'Prism Ranger',       rarity: 'Rare',      power: 73,   pool: 'ad' },
  { id: 'ad_r4', name: 'Echo Warrior',       rarity: 'Rare',      power: 71,   pool: 'ad' },
  { id: 'ad_r5', name: 'Lumen Rogue',        rarity: 'Rare',      power: 69,   pool: 'ad' },
  { id: 'ad_r6', name: 'Signal Scout',       rarity: 'Rare',      power: 67,   pool: 'ad' },

  // ============================================================
  // BATTLE PASS EXCLUSIVE — reward only, never rolled in packs
  // ============================================================
  { id: 'bp1', name: 'SEASON CHAMPION',      rarity: 'Divine',    power: 10001, pool: 'battlepass' },
  { id: 'bp2', name: 'BATTLE HERALD',        rarity: 'Mythic',    power: 999,   pool: 'battlepass' },
  { id: 'bp3', name: 'MONTHLY WARLORD',      rarity: 'Legendary', power: 950,   pool: 'battlepass' },

  {id: 'ex1', name: 'DIVINE LORD (for V1)', rarity: 'Divine', power: 9999, pool: 'admin' },
  {id: 'ex2', name: 'PANTHEON BREAKER', rarity: 'Divine', power: 9999, pool: 'admin' },
  {id: 'ex3', name: 'Nebula Kraken', rarity: 'Special', power: 50000, pool: 'admin' },

  // New Cards added here SECTION 2
  // ============================================================
// NEW STANDARD CARDS
// ============================================================

// ── MYTHIC ──
{ id: 'm31', name: 'Entropy Sovereign',    rarity: 'Mythic', power: 999, pool: 'standard' },
{ id: 'm32', name: 'Solaris Overlord',     rarity: 'Mythic', power: 999, pool: 'standard' },
{ id: 'm33', name: 'Lunar Architect',      rarity: 'Mythic', power: 999, pool: 'standard' },
{ id: 'm34', name: 'Nebula Warden',        rarity: 'Mythic', power: 999, pool: 'standard' },
{ id: 'm35', name: 'Singularity King',     rarity: 'Mythic', power: 999, pool: 'standard' },
{ id: 'm36', name: 'Photon Overlord',      rarity: 'Mythic', power: 999, pool: 'standard' },
{ id: 'm37', name: 'Graviton Emperor',     rarity: 'Mythic', power: 999, pool: 'standard' },
{ id: 'm38', name: 'Dark Matter Titan',    rarity: 'Mythic', power: 999, pool: 'standard' },

// ── LEGENDARY ──
{ id: 'l61', name: 'Nebula Dragon',        rarity: 'Legendary', power: 930, pool: 'standard' },
{ id: 'l62', name: 'Photon Samurai',       rarity: 'Legendary', power: 910, pool: 'standard' },
{ id: 'l63', name: 'Gravity Knight',       rarity: 'Legendary', power: 900, pool: 'standard' },
{ id: 'l64', name: 'Solar Paladin',        rarity: 'Legendary', power: 880, pool: 'standard' },
{ id: 'l65', name: 'Lunar Assassin',       rarity: 'Legendary', power: 870, pool: 'standard' },
{ id: 'l66', name: 'Quantum Revenant',     rarity: 'Legendary', power: 860, pool: 'standard' },
{ id: 'l67', name: 'Void Reaper',          rarity: 'Legendary', power: 940, pool: 'standard' },
{ id: 'l68', name: 'Neon Titan',           rarity: 'Legendary', power: 920, pool: 'standard' },
{ id: 'l69', name: 'Binary Samurai',       rarity: 'Legendary', power: 850, pool: 'standard' },
{ id: 'l70', name: 'Fractal Warlord',      rarity: 'Legendary', power: 870, pool: 'standard' },

// ── EPIC ──
{ id: 'e44', name: 'Photon Assassin',      rarity: 'Epic', power: 97, pool: 'standard' },
{ id: 'e45', name: 'Gravity Archer',       rarity: 'Epic', power: 95, pool: 'standard' },
{ id: 'e46', name: 'Nebula Mage',          rarity: 'Epic', power: 93, pool: 'standard' },
{ id: 'e47', name: 'Solar Hunter',         rarity: 'Epic', power: 91, pool: 'standard' },
{ id: 'e48', name: 'Lunar Knight',         rarity: 'Epic', power: 90, pool: 'standard' },
{ id: 'e49', name: 'Entropy Rogue',        rarity: 'Epic', power: 89, pool: 'standard' },
{ id: 'e50', name: 'Dark Matter Scout',    rarity: 'Epic', power: 88, pool: 'standard' },

// ── RARE ──
{ id: 'r51', name: 'Photon Scout',         rarity: 'Rare', power: 76, pool: 'standard' },
{ id: 'r52', name: 'Gravity Ranger',       rarity: 'Rare', power: 74, pool: 'standard' },
{ id: 'r53', name: 'Nebula Rogue',         rarity: 'Rare', power: 73, pool: 'standard' },
{ id: 'r54', name: 'Solar Archer',         rarity: 'Rare', power: 72, pool: 'standard' },
{ id: 'r55', name: 'Lunar Mage',           rarity: 'Rare', power: 70, pool: 'standard' },

// ── COMMON ──
{ id: 'c41', name: 'Photon Wisp',          rarity: 'Common', power: 45, pool: 'standard' },
{ id: 'c42', name: 'Gravity Wisp',         rarity: 'Common', power: 40, pool: 'standard' },
{ id: 'c43', name: 'Nebula Wisp',          rarity: 'Common', power: 35, pool: 'standard' },
{ id: 'c44', name: 'Solar Wisp',           rarity: 'Common', power: 30, pool: 'standard' },
{ id: 'c45', name: 'Lunar Wisp',           rarity: 'Common', power: 25, pool: 'standard' },

// ============================================================
// NEW ASH CARDS
// ============================================================

// ── MYTHIC ──
{ id: 'a_m7', name: 'Infernal Titan',      rarity: 'Mythic', power: 999, pool: 'ash' },
{ id: 'a_m8', name: 'Blaze Sovereign',     rarity: 'Mythic', power: 999, pool: 'ash' },

// ── LEGENDARY ──
{ id: 'a_l11', name: 'Inferno Samurai',    rarity: 'Legendary', power: 930, pool: 'ash' },
{ id: 'a_l12', name: 'Blaze Knight',       rarity: 'Legendary', power: 910, pool: 'ash' },
{ id: 'a_l13', name: 'Cinder Titan',       rarity: 'Legendary', power: 900, pool: 'ash' },

// ── EPIC ──
{ id: 'a_e11', name: 'Infernal Archer',    rarity: 'Epic', power: 97, pool: 'ash' },
{ id: 'a_e12', name: 'Blaze Assassin',     rarity: 'Epic', power: 95, pool: 'ash' },

// ── RARE ──
{ id: 'a_r11', name: 'Inferno Scout',      rarity: 'Rare', power: 77, pool: 'ash' },
{ id: 'a_r12', name: 'Blaze Ranger',       rarity: 'Rare', power: 75, pool: 'ash' },

// ============================================================
// NEW AD CARDS
// ============================================================

// ── MYTHIC ──
{ id: 'ad_m5', name: 'Aurora Sovereign',   rarity: 'Mythic', power: 999, pool: 'ad' },
{ id: 'ad_m6', name: 'Prism Emperor',      rarity: 'Mythic', power: 999, pool: 'ad' },

// ── LEGENDARY ──
{ id: 'ad_l9',  name: 'Aurora Knight',     rarity: 'Legendary', power: 930, pool: 'ad' },
{ id: 'ad_l10', name: 'Prism Dragon',      rarity: 'Legendary', power: 920, pool: 'ad' },
{ id: 'ad_l11', name: 'Lumen Samurai',     rarity: 'Legendary', power: 900, pool: 'ad' },

// ── EPIC ──
{ id: 'ad_e8', name: 'Aurora Archer',      rarity: 'Epic', power: 97, pool: 'ad' },
{ id: 'ad_e9', name: 'Prism Assassin',     rarity: 'Epic', power: 95, pool: 'ad' },

// ── RARE ──
{ id: 'ad_r7', name: 'Aurora Scout',       rarity: 'Rare', power: 77, pool: 'ad' },
{ id: 'ad_r8', name: 'Prism Rogue',        rarity: 'Rare', power: 74, pool: 'ad' },

// ── MYTHIC ──
{ id: 'm61', name: 'Abyss Sovereign', rarity: 'Mythic', power: 999, pool: 'standard' },
{ id: 'm62', name: 'Void Cataclysm', rarity: 'Mythic', power: 999, pool: 'standard' },
{ id: 'm63', name: 'Oblivion Monarch', rarity: 'Mythic', power: 999, pool: 'standard' },
{ id: 'm64', name: 'Dark Singularity', rarity: 'Mythic', power: 999, pool: 'standard' },
{ id: 'm65', name: 'Abyss Titan', rarity: 'Mythic', power: 999, pool: 'standard' },

// ── LEGENDARY ──
{ id: 'l71', name: 'Void Leviathan', rarity: 'Legendary', power: 940, pool: 'standard' },
{ id: 'l72', name: 'Abyss Knight', rarity: 'Legendary', power: 910, pool: 'standard' },
{ id: 'l73', name: 'Oblivion Reaper', rarity: 'Legendary', power: 930, pool: 'standard' },
{ id: 'l74', name: 'Dark Rift Warden', rarity: 'Legendary', power: 900, pool: 'standard' },
{ id: 'l75', name: 'Void Tyrant', rarity: 'Legendary', power: 920, pool: 'standard' },
{ id: 'l76', name: 'Abyss Archer', rarity: 'Legendary', power: 880, pool: 'standard' },
{ id: 'l77', name: 'Singularity Knight', rarity: 'Legendary', power: 905, pool: 'standard' },
{ id: 'l78', name: 'Voidbreaker Samurai', rarity: 'Legendary', power: 890, pool: 'standard' },

// ── EPIC ──
{ id: 'e51', name: 'Void Hunter', rarity: 'Epic', power: 96, pool: 'standard' },
{ id: 'e52', name: 'Abyss Rogue', rarity: 'Epic', power: 94, pool: 'standard' },
{ id: 'e53', name: 'Dark Mage', rarity: 'Epic', power: 92, pool: 'standard' },
{ id: 'e54', name: 'Rift Assassin', rarity: 'Epic', power: 91, pool: 'standard' },
{ id: 'e55', name: 'Voidblade Warrior', rarity: 'Epic', power: 90, pool: 'standard' },
{ id: 'e56', name: 'Abyss Stalker', rarity: 'Epic', power: 89, pool: 'standard' },

// ── RARE ──
{ id: 'r56', name: 'Void Scout MK-III', rarity: 'Rare', power: 76, pool: 'standard' },
{ id: 'r57', name: 'Abyss Ranger', rarity: 'Rare', power: 74, pool: 'standard' },
{ id: 'r58', name: 'Dark Archer', rarity: 'Rare', power: 72, pool: 'standard' },
{ id: 'r59', name: 'Rift Warrior', rarity: 'Rare', power: 71, pool: 'standard' },
{ id: 'r60', name: 'Void Initiate', rarity: 'Rare', power: 70, pool: 'standard' },

// ── COMMON ──
{ id: 'c46', name: 'Void Fragment', rarity: 'Common', power: 45, pool: 'standard' },
{ id: 'c47', name: 'Abyss Wisp', rarity: 'Common', power: 40, pool: 'standard' },
{ id: 'c48', name: 'Dark Fragment', rarity: 'Common', power: 35, pool: 'standard' },
{ id: 'c49', name: 'Rift Wisp', rarity: 'Common', power: 30, pool: 'standard' },
{ id: 'c50', name: 'Void Echo', rarity: 'Common', power: 25, pool: 'standard' },
// ── MYTHIC ──
{ id: 'm66', name: 'Core AI Overmind', rarity: 'Mythic', power: 999, pool: 'standard' },
{ id: 'm67', name: 'Neural Nexus', rarity: 'Mythic', power: 999, pool: 'standard' },
{ id: 'm68', name: 'Protocol Emperor', rarity: 'Mythic', power: 999, pool: 'standard' },

// ── LEGENDARY ──
{ id: 'l79', name: 'Cyber Overdrive Titan', rarity: 'Legendary', power: 930, pool: 'standard' },
{ id: 'l80', name: 'Neural Samurai', rarity: 'Legendary', power: 900, pool: 'standard' },
{ id: 'l81', name: 'Data Overlord X', rarity: 'Legendary', power: 920, pool: 'standard' },
{ id: 'l82', name: 'Protocol Knight', rarity: 'Legendary', power: 880, pool: 'standard' },
{ id: 'l83', name: 'Cyber Phantom X', rarity: 'Legendary', power: 910, pool: 'standard' },

// ── EPIC ──
{ id: 'e57', name: 'Neural Assassin', rarity: 'Epic', power: 96, pool: 'standard' },
{ id: 'e58', name: 'Protocol Archer', rarity: 'Epic', power: 94, pool: 'standard' },
{ id: 'e59', name: 'Data Hacker', rarity: 'Epic', power: 92, pool: 'standard' },
{ id: 'e60', name: 'Cyber Enforcer', rarity: 'Epic', power: 90, pool: 'standard' },

// ── RARE ──
{ id: 'r61', name: 'Data Scout X', rarity: 'Rare', power: 75, pool: 'standard' },
{ id: 'r62', name: 'Cyber Ranger X', rarity: 'Rare', power: 73, pool: 'standard' },
{ id: 'r63', name: 'Protocol Mage', rarity: 'Rare', power: 71, pool: 'standard' },

// ── COMMON ──
{ id: 'c51', name: 'Data Fragment', rarity: 'Common', power: 45, pool: 'standard' },
{ id: 'c52', name: 'Cyber Node', rarity: 'Common', power: 40, pool: 'standard' },
{ id: 'c53', name: 'Protocol Wisp', rarity: 'Common', power: 35, pool: 'standard' },
// ── MYTHIC ──
{ id: 'a_m9', name: 'Hellfire Sovereign', rarity: 'Mythic', power: 999, pool: 'ash' },
{ id: 'a_m10', name: 'Inferno Overmind', rarity: 'Mythic', power: 999, pool: 'ash' },

// ── LEGENDARY ──
{ id: 'a_l14', name: 'Hellfire Dragon', rarity: 'Legendary', power: 940, pool: 'ash' },
{ id: 'a_l15', name: 'Infernal Knight', rarity: 'Legendary', power: 920, pool: 'ash' },
{ id: 'a_l16', name: 'Ashen Warlord', rarity: 'Legendary', power: 900, pool: 'ash' },

// ── EPIC ──
{ id: 'a_e13', name: 'Hellfire Assassin', rarity: 'Epic', power: 96, pool: 'ash' },
{ id: 'a_e14', name: 'Inferno Archer', rarity: 'Epic', power: 94, pool: 'ash' },

// ── RARE ──
{ id: 'a_r13', name: 'Ashen Scout', rarity: 'Rare', power: 76, pool: 'ash' },
{ id: 'a_r14', name: 'Cinder Ranger X', rarity: 'Rare', power: 74, pool: 'ash' },
// ── MYTHIC ──
{ id: 'ad_m7', name: 'Aurora Overmind', rarity: 'Mythic', power: 999, pool: 'ad' },
{ id: 'ad_m8', name: 'Prism Singularity', rarity: 'Mythic', power: 999, pool: 'ad' },

// ── LEGENDARY ──
{ id: 'ad_l12', name: 'Aurora Dragon', rarity: 'Legendary', power: 930, pool: 'ad' },
{ id: 'ad_l13', name: 'Prism Knight X', rarity: 'Legendary', power: 910, pool: 'ad' },
{ id: 'ad_l14', name: 'Radiant Emperor', rarity: 'Legendary', power: 920, pool: 'ad' },

// ── EPIC ──
{ id: 'ad_e10', name: 'Aurora Assassin', rarity: 'Epic', power: 96, pool: 'ad' },
{ id: 'ad_e11', name: 'Prism Archer X', rarity: 'Epic', power: 94, pool: 'ad' },

// ── RARE ──
{ id: 'ad_r9', name: 'Aurora Scout X', rarity: 'Rare', power: 76, pool: 'ad' },
{ id: 'ad_r10', name: 'Prism Ranger X', rarity: 'Rare', power: 74, pool: 'ad' },
// ── DIVINE ──
{ id: 'd21', name: 'CELESTIAL GODKING', rarity: 'Divine', power: 10000, pool: 'standard' },
{ id: 'd22', name: 'ABSOLUTE OMNISCIENCE', rarity: 'Divine', power: 9999, pool: 'standard' },
{ id: 'd23', name: 'ETERNAL SUPREMACY', rarity: 'Divine', power: 9998, pool: 'standard' },
{ id: 'd24', name: 'COSMIC ASCENSION', rarity: 'Divine', power: 9997, pool: 'standard' },
{ id: 'd25', name: 'REALITY SHAPER', rarity: 'Divine', power: 9996, pool: 'standard' },
{ id: 'd26', name: 'INFINITE PARADOX', rarity: 'Divine', power: 9995, pool: 'standard' },
{ id: 'd27', name: 'PRIMORDIAL CREATOR', rarity: 'Divine', power: 9994, pool: 'standard' },
{ id: 'd28', name: 'VOID GENESIS', rarity: 'Divine', power: 9993, pool: 'standard' },
{ id: 'd29', name: 'STARFORGE DEITY', rarity: 'Divine', power: 9992, pool: 'standard' },
{ id: 'd30', name: 'TIME ABSOLUTE', rarity: 'Divine', power: 9991, pool: 'standard' },
{ id: 'd31', name: 'DIMENSION BREAKER', rarity: 'Divine', power: 9990, pool: 'standard' },
{ id: 'd32', name: 'UNIVERSAL CORE', rarity: 'Divine', power: 9989, pool: 'standard' },
{ id: 'd33', name: 'GALACTIC OVERGOD', rarity: 'Divine', power: 9988, pool: 'standard' },
{ id: 'd34', name: 'FINAL JUDGMENT', rarity: 'Divine', power: 9987, pool: 'standard' },
{ id: 'd35', name: 'OMEGA CREATOR', rarity: 'Divine', power: 9986, pool: 'standard' },
{ id: 'd36', name: 'PRIME ARCHITECT', rarity: 'Divine', power: 9985, pool: 'standard' },
{ id: 'd37', name: 'ABSOLUTE VOID', rarity: 'Divine', power: 9984, pool: 'standard' },
{ id: 'd38', name: 'INFINITY CORE', rarity: 'Divine', power: 9983, pool: 'standard' },
{ id: 'd39', name: 'COSMIC DOMINION', rarity: 'Divine', power: 9982, pool: 'standard' },
{ id: 'd40', name: 'ULTIMATE SINGULARITY', rarity: 'Divine', power: 9981, pool: 'standard' },
// ── MYTHIC ──
{ id: 'm111', name: 'Paradox Sovereign', rarity: 'Mythic', power: 999, pool: 'standard' },
{ id: 'm112', name: 'Eternal Nexus', rarity: 'Mythic', power: 999, pool: 'standard' },
{ id: 'm113', name: 'Hyperion Overlord', rarity: 'Mythic', power: 999, pool: 'standard' },
{ id: 'm114', name: 'Omega Architect', rarity: 'Mythic', power: 999, pool: 'standard' },
{ id: 'm115', name: 'Singularity Emperor', rarity: 'Mythic', power: 999, pool: 'standard' },
{ id: 'm116', name: 'Chrono Overmind', rarity: 'Mythic', power: 999, pool: 'standard' },
{ id: 'm117', name: 'Astral Sovereign X', rarity: 'Mythic', power: 999, pool: 'standard' },
{ id: 'm118', name: 'Void Ascendant', rarity: 'Mythic', power: 999, pool: 'standard' },
{ id: 'm119', name: 'Neon Godform', rarity: 'Mythic', power: 999, pool: 'standard' },
{ id: 'm120', name: 'Cyber Omnilord', rarity: 'Mythic', power: 999, pool: 'standard' },
{ id: 'm121', name: 'Data Singularity', rarity: 'Mythic', power: 999, pool: 'standard' },
{ id: 'm122', name: 'Holo Infinity', rarity: 'Mythic', power: 999, pool: 'standard' },
{ id: 'm123', name: 'Quantum Apex', rarity: 'Mythic', power: 999, pool: 'standard' },
{ id: 'm124', name: 'Static Omniscient', rarity: 'Mythic', power: 999, pool: 'standard' },
{ id: 'm125', name: 'Pixel Overmind X', rarity: 'Mythic', power: 999, pool: 'standard' },

// ── LEGENDARY ──
{ id: 'l121', name: 'Paradox Dragon', rarity: 'Legendary', power: 930, pool: 'standard' },
{ id: 'l122', name: 'Eternal Samurai', rarity: 'Legendary', power: 910, pool: 'standard' },
{ id: 'l123', name: 'Hyperion Knight', rarity: 'Legendary', power: 900, pool: 'standard' },
{ id: 'l124', name: 'Omega Warlord X', rarity: 'Legendary', power: 920, pool: 'standard' },
{ id: 'l125', name: 'Singularity Paladin', rarity: 'Legendary', power: 880, pool: 'standard' },
{ id: 'l126', name: 'Chrono Assassin X', rarity: 'Legendary', power: 940, pool: 'standard' },
{ id: 'l127', name: 'Astral Revenant X', rarity: 'Legendary', power: 900, pool: 'standard' },
{ id: 'l128', name: 'Void Titan X', rarity: 'Legendary', power: 930, pool: 'standard' },
{ id: 'l129', name: 'Neon Dragon X', rarity: 'Legendary', power: 910, pool: 'standard' },
{ id: 'l130', name: 'Cyber Samurai X', rarity: 'Legendary', power: 890, pool: 'standard' },
{ id: 'l131', name: 'Data Warlord X', rarity: 'Legendary', power: 880, pool: 'standard' },
{ id: 'l132', name: 'Holo Knight X', rarity: 'Legendary', power: 870, pool: 'standard' },
{ id: 'l133', name: 'Quantum Revenant X', rarity: 'Legendary', power: 900, pool: 'standard' },
{ id: 'l134', name: 'Static Titan X', rarity: 'Legendary', power: 920, pool: 'standard' },
{ id: 'l135', name: 'Pixel Samurai X', rarity: 'Legendary', power: 880, pool: 'standard' },

// ── EPIC ──
{ id: 'e121', name: 'Paradox Assassin', rarity: 'Epic', power: 97, pool: 'standard' },
{ id: 'e122', name: 'Eternal Hunter', rarity: 'Epic', power: 96, pool: 'standard' },
{ id: 'e123', name: 'Hyperion Mage', rarity: 'Epic', power: 95, pool: 'standard' },
{ id: 'e124', name: 'Omega Rogue', rarity: 'Epic', power: 94, pool: 'standard' },
{ id: 'e125', name: 'Singularity Archer', rarity: 'Epic', power: 93, pool: 'standard' },
{ id: 'e126', name: 'Chrono Warrior', rarity: 'Epic', power: 92, pool: 'standard' },
{ id: 'e127', name: 'Astral Blade X', rarity: 'Epic', power: 91, pool: 'standard' },
{ id: 'e128', name: 'Void Hunter X', rarity: 'Epic', power: 90, pool: 'standard' },
{ id: 'e129', name: 'Neon Assassin X', rarity: 'Epic', power: 89, pool: 'standard' },
{ id: 'e130', name: 'Cyber Rogue X', rarity: 'Epic', power: 88, pool: 'standard' },
// ============================================================
// STANDARD POOL CONTINUED
// ============================================================

// ── MYTHIC ──
{ id: 'm126', name: 'Galactic Ascendant', rarity: 'Mythic', power: 999, pool: 'standard' },
{ id: 'm127', name: 'Stellar Overmind X', rarity: 'Mythic', power: 999, pool: 'standard' },
{ id: 'm128', name: 'Orbital Paragon', rarity: 'Mythic', power: 999, pool: 'standard' },
{ id: 'm129', name: 'Nebula Sovereign X', rarity: 'Mythic', power: 999, pool: 'standard' },
{ id: 'm130', name: 'Photon Architect X', rarity: 'Mythic', power: 999, pool: 'standard' },
{ id: 'm131', name: 'Gravity Overlord X', rarity: 'Mythic', power: 999, pool: 'standard' },
{ id: 'm132', name: 'Solar Apex', rarity: 'Mythic', power: 999, pool: 'standard' },
{ id: 'm133', name: 'Lunar Ascendant X', rarity: 'Mythic', power: 999, pool: 'standard' },
{ id: 'm134', name: 'Aether Sovereign X', rarity: 'Mythic', power: 999, pool: 'standard' },
{ id: 'm135', name: 'Binary Omnilord', rarity: 'Mythic', power: 999, pool: 'standard' },

// ── LEGENDARY ──
{ id: 'l136', name: 'Galactic Dragon X', rarity: 'Legendary', power: 930, pool: 'standard' },
{ id: 'l137', name: 'Stellar Samurai X', rarity: 'Legendary', power: 910, pool: 'standard' },
{ id: 'l138', name: 'Orbital Knight X', rarity: 'Legendary', power: 900, pool: 'standard' },
{ id: 'l139', name: 'Nebula Paladin X', rarity: 'Legendary', power: 880, pool: 'standard' },
{ id: 'l140', name: 'Photon Revenant X', rarity: 'Legendary', power: 920, pool: 'standard' },
{ id: 'l141', name: 'Gravity Assassin X', rarity: 'Legendary', power: 940, pool: 'standard' },
{ id: 'l142', name: 'Solar Warlord X', rarity: 'Legendary', power: 900, pool: 'standard' },
{ id: 'l143', name: 'Lunar Titan X', rarity: 'Legendary', power: 930, pool: 'standard' },
{ id: 'l144', name: 'Aether Dragon X', rarity: 'Legendary', power: 910, pool: 'standard' },
{ id: 'l145', name: 'Binary Warlord X', rarity: 'Legendary', power: 890, pool: 'standard' },

// ── EPIC ──
{ id: 'e131', name: 'Galactic Assassin', rarity: 'Epic', power: 97, pool: 'standard' },
{ id: 'e132', name: 'Stellar Hunter', rarity: 'Epic', power: 96, pool: 'standard' },
{ id: 'e133', name: 'Orbital Mage', rarity: 'Epic', power: 95, pool: 'standard' },
{ id: 'e134', name: 'Nebula Rogue', rarity: 'Epic', power: 94, pool: 'standard' },
{ id: 'e135', name: 'Photon Archer', rarity: 'Epic', power: 93, pool: 'standard' },
{ id: 'e136', name: 'Gravity Warrior', rarity: 'Epic', power: 92, pool: 'standard' },
{ id: 'e137', name: 'Solar Blade X', rarity: 'Epic', power: 91, pool: 'standard' },
{ id: 'e138', name: 'Lunar Hunter X', rarity: 'Epic', power: 90, pool: 'standard' },
{ id: 'e139', name: 'Aether Assassin X', rarity: 'Epic', power: 89, pool: 'standard' },
{ id: 'e140', name: 'Binary Rogue X', rarity: 'Epic', power: 88, pool: 'standard' },

// ── RARE ──
{ id: 'r64', name: 'Galactic Ranger', rarity: 'Rare', power: 77, pool: 'standard' },
{ id: 'r65', name: 'Stellar Archer', rarity: 'Rare', power: 75, pool: 'standard' },
{ id: 'r66', name: 'Orbital Scout', rarity: 'Rare', power: 74, pool: 'standard' },
{ id: 'r67', name: 'Nebula Mage X', rarity: 'Rare', power: 73, pool: 'standard' },
{ id: 'r68', name: 'Photon Knight X', rarity: 'Rare', power: 72, pool: 'standard' },
{ id: 'r69', name: 'Gravity Rogue X', rarity: 'Rare', power: 71, pool: 'standard' },
{ id: 'r70', name: 'Solar Warrior X', rarity: 'Rare', power: 70, pool: 'standard' },
{ id: 'r71', name: 'Lunar Scout X', rarity: 'Rare', power: 69, pool: 'standard' },
{ id: 'r72', name: 'Aether Ranger X', rarity: 'Rare', power: 68, pool: 'standard' },
{ id: 'r73', name: 'Binary Archer X', rarity: 'Rare', power: 67, pool: 'standard' },

// ── COMMON ──
{ id: 'c54', name: 'Galactic Wisp', rarity: 'Common', power: 50, pool: 'standard' },
{ id: 'c55', name: 'Stellar Wisp', rarity: 'Common', power: 48, pool: 'standard' },
{ id: 'c56', name: 'Orbital Wisp', rarity: 'Common', power: 46, pool: 'standard' },
{ id: 'c57', name: 'Nebula Wisp X', rarity: 'Common', power: 44, pool: 'standard' },
{ id: 'c58', name: 'Photon Wisp X', rarity: 'Common', power: 42, pool: 'standard' },
{ id: 'c59', name: 'Gravity Wisp X', rarity: 'Common', power: 40, pool: 'standard' },
{ id: 'c60', name: 'Solar Wisp X', rarity: 'Common', power: 38, pool: 'standard' },
{ id: 'c61', name: 'Lunar Wisp X', rarity: 'Common', power: 36, pool: 'standard' },
{ id: 'c62', name: 'Aether Wisp X', rarity: 'Common', power: 34, pool: 'standard' },
{ id: 'c63', name: 'Binary Wisp X', rarity: 'Common', power: 32, pool: 'standard' },
// ── MYTHIC ──
{ id: 'a_m11', name: 'Hellstorm Sovereign', rarity: 'Mythic', power: 999, pool: 'ash' },
{ id: 'a_m12', name: 'Cinder Overmind X', rarity: 'Mythic', power: 999, pool: 'ash' },

// ── LEGENDARY ──
{ id: 'a_l17', name: 'Hellstorm Dragon', rarity: 'Legendary', power: 940, pool: 'ash' },
{ id: 'a_l18', name: 'Cinder Titan X', rarity: 'Legendary', power: 920, pool: 'ash' },
{ id: 'a_l19', name: 'Blaze Samurai X', rarity: 'Legendary', power: 900, pool: 'ash' },

// ── EPIC ──
{ id: 'a_e15', name: 'Hellstorm Assassin', rarity: 'Epic', power: 96, pool: 'ash' },
{ id: 'a_e16', name: 'Cinder Hunter X', rarity: 'Epic', power: 94, pool: 'ash' },

// ── RARE ──
{ id: 'a_r15', name: 'Hellstorm Scout', rarity: 'Rare', power: 76, pool: 'ash' },
{ id: 'a_r16', name: 'Cinder Ranger X', rarity: 'Rare', power: 74, pool: 'ash' },
// ── MYTHIC ──
{ id: 'ad_m9', name: 'Radiant Overmind X', rarity: 'Mythic', power: 999, pool: 'ad' },
{ id: 'ad_m10', name: 'Aurora Sovereign X', rarity: 'Mythic', power: 999, pool: 'ad' },

// ── LEGENDARY ──
{ id: 'ad_l15', name: 'Radiant Dragon X', rarity: 'Legendary', power: 930, pool: 'ad' },
{ id: 'ad_l16', name: 'Aurora Samurai X', rarity: 'Legendary', power: 910, pool: 'ad' },
{ id: 'ad_l17', name: 'Prism Titan X', rarity: 'Legendary', power: 900, pool: 'ad' },

// ── EPIC ──
{ id: 'ad_e12', name: 'Radiant Assassin X', rarity: 'Epic', power: 96, pool: 'ad' },
{ id: 'ad_e13', name: 'Aurora Hunter X', rarity: 'Epic', power: 94, pool: 'ad' },

// ── RARE ──
{ id: 'ad_r11', name: 'Radiant Scout X', rarity: 'Rare', power: 76, pool: 'ad' },
{ id: 'ad_r12', name: 'Aurora Ranger X', rarity: 'Rare', power: 74, pool: 'ad' },
// ── MYTHIC ──
{ id: 'm206', name: 'Omega Singularity', rarity: 'Mythic', power: 999, pool: 'standard' },
{ id: 'm207', name: 'Hypercore Sovereign', rarity: 'Mythic', power: 999, pool: 'standard' },
{ id: 'm208', name: 'Fractal Ascendant', rarity: 'Mythic', power: 999, pool: 'standard' },
{ id: 'm209', name: 'Pulse Overmind', rarity: 'Mythic', power: 999, pool: 'standard' },
{ id: 'm210', name: 'Null Emperor', rarity: 'Mythic', power: 999, pool: 'standard' },

// ── LEGENDARY ──
{ id: 'l216', name: 'Omega Dragon', rarity: 'Legendary', power: 930, pool: 'standard' },
{ id: 'l217', name: 'Hypercore Knight', rarity: 'Legendary', power: 900, pool: 'standard' },
{ id: 'l218', name: 'Fractal Samurai', rarity: 'Legendary', power: 910, pool: 'standard' },
{ id: 'l219', name: 'Pulse Warlord', rarity: 'Legendary', power: 920, pool: 'standard' },
{ id: 'l220', name: 'Null Revenant', rarity: 'Legendary', power: 940, pool: 'standard' },
{ id: 'l221', name: 'Omega Paladin', rarity: 'Legendary', power: 880, pool: 'standard' },
{ id: 'l222', name: 'Hypercore Assassin', rarity: 'Legendary', power: 930, pool: 'standard' },
{ id: 'l223', name: 'Fractal Titan', rarity: 'Legendary', power: 920, pool: 'standard' },
{ id: 'l224', name: 'Pulse Samurai', rarity: 'Legendary', power: 900, pool: 'standard' },
{ id: 'l225', name: 'Null Knight', rarity: 'Legendary', power: 890, pool: 'standard' },

// ── EPIC ──
{ id: 'e206', name: 'Omega Assassin', rarity: 'Epic', power: 97, pool: 'standard' },
{ id: 'e207', name: 'Hypercore Rogue', rarity: 'Epic', power: 96, pool: 'standard' },
{ id: 'e208', name: 'Fractal Mage', rarity: 'Epic', power: 95, pool: 'standard' },
{ id: 'e209', name: 'Pulse Hunter', rarity: 'Epic', power: 94, pool: 'standard' },
{ id: 'e210', name: 'Null Archer', rarity: 'Epic', power: 93, pool: 'standard' },

// ── RARE ──
{ id: 'r74', name: 'Omega Ranger', rarity: 'Rare', power: 77, pool: 'standard' },
{ id: 'r75', name: 'Hypercore Scout', rarity: 'Rare', power: 75, pool: 'standard' },
{ id: 'r76', name: 'Fractal Archer', rarity: 'Rare', power: 74, pool: 'standard' },
{ id: 'r77', name: 'Pulse Warrior', rarity: 'Rare', power: 73, pool: 'standard' },
{ id: 'r78', name: 'Null Mage', rarity: 'Rare', power: 72, pool: 'standard' },

// ── COMMON ──
{ id: 'c64', name: 'Omega Wisp', rarity: 'Common', power: 50, pool: 'standard' },
{ id: 'c65', name: 'Hypercore Wisp', rarity: 'Common', power: 48, pool: 'standard' },
{ id: 'c66', name: 'Fractal Wisp X', rarity: 'Common', power: 46, pool: 'standard' },
{ id: 'c67', name: 'Pulse Wisp X', rarity: 'Common', power: 44, pool: 'standard' },
{ id: 'c68', name: 'Null Wisp X', rarity: 'Common', power: 42, pool: 'standard' },
{ id: 'l226', name: 'Omega Dragon Prime', rarity: 'Legendary', power: 940, pool: 'standard' },
{ id: 'l227', name: 'Fractal Samurai Prime', rarity: 'Legendary', power: 930, pool: 'standard' },
{ id: 'l228', name: 'Pulse Warlord Prime', rarity: 'Legendary', power: 935, pool: 'standard' },

{ id: 'e211', name: 'Omega Assassin Prime', rarity: 'Epic', power: 97, pool: 'standard' },
{ id: 'e212', name: 'Fractal Mage Prime', rarity: 'Epic', power: 96, pool: 'standard' },
{ id: 'm211', name: 'Omega Sovereign Ascended', rarity: 'Mythic', power: 999, pool: 'standard' },
{ id: 'm212', name: 'Fractal Overlord Ascended', rarity: 'Mythic', power: 999, pool: 'standard' },

{ id: 'l229', name: 'Omega Dragon Ascended', rarity: 'Legendary', power: 940, pool: 'standard' },
{ id: 'l230', name: 'Pulse Titan Ascended', rarity: 'Legendary', power: 940, pool: 'standard' },
{ id: 'm213', name: 'Corrupted Omega Sovereign', rarity: 'Mythic', power: 999, pool: 'standard' },
{ id: 'm214', name: 'Corrupted Fractal Overmind', rarity: 'Mythic', power: 999, pool: 'standard' },

{ id: 'l231', name: 'Corrupted Pulse Dragon', rarity: 'Legendary', power: 940, pool: 'standard' },
{ id: 'l232', name: 'Corrupted Null Titan', rarity: 'Legendary', power: 930, pool: 'standard' },

{ id: 'e213', name: 'Corrupted Omega Assassin', rarity: 'Epic', power: 97, pool: 'standard' },
{ id: 'm215', name: 'Overclocked Cyber Overmind', rarity: 'Mythic', power: 999, pool: 'standard' },
{ id: 'm216', name: 'Overclocked Data Sovereign', rarity: 'Mythic', power: 999, pool: 'standard' },

{ id: 'l233', name: 'Overclocked Cyber Dragon', rarity: 'Legendary', power: 930, pool: 'standard' },
{ id: 'l234', name: 'Overclocked Data Samurai', rarity: 'Legendary', power: 910, pool: 'standard' },

{ id: 'e214', name: 'Overclocked Cyber Assassin', rarity: 'Epic', power: 97, pool: 'standard' },
{ id: 'a_m13', name: 'Ashen Overlord Prime', rarity: 'Mythic', power: 999, pool: 'ash' },
{ id: 'a_m14', name: 'Inferno Sovereign Ascended', rarity: 'Mythic', power: 999, pool: 'ash' },

{ id: 'a_l20', name: 'Blaze Dragon Prime', rarity: 'Legendary', power: 940, pool: 'ash' },
{ id: 'a_l21', name: 'Cinder Titan Ascended', rarity: 'Legendary', power: 930, pool: 'ash' },

{ id: 'a_e17', name: 'Ashen Assassin Prime', rarity: 'Epic', power: 97, pool: 'ash' },
{ id: 'ad_m11', name: 'Aurora Sovereign Ascended', rarity: 'Mythic', power: 999, pool: 'ad' },
{ id: 'ad_m12', name: 'Radiant Overmind Prime', rarity: 'Mythic', power: 999, pool: 'ad' },

{ id: 'ad_l18', name: 'Aurora Dragon Prime', rarity: 'Legendary', power: 940, pool: 'ad' },
{ id: 'ad_l19', name: 'Prism Titan Ascended', rarity: 'Legendary', power: 930, pool: 'ad' },

{ id: 'ad_e14', name: 'Radiant Assassin Prime', rarity: 'Epic', power: 97, pool: 'ad' },

// Fanatic Commons
{ id: 'c69', name: 'Fanatic Wisp', rarity: 'Common', power: 50, pool: 'standard' },
{ id: 'c70', name: 'Fanatic Fragment', rarity: 'Common', power: 45, pool: 'standard' },
{ id: 'c71', name: 'Fanatic Node', rarity: 'Common', power: 40, pool: 'standard' },
{ id: 'c72', name: 'Fanatic Wisp X', rarity: 'Common', power: 35, pool: 'standard' },
{ id: 'c73', name: 'Fanatic Wisp Prime', rarity: 'Common', power: 30, pool: 'standard'},
{ id: 'c74', name: 'Fanatic Wisp Ascended', rarity: 'Common', power: 25, pool: 'standard'},
{ id: 'c75', name: 'Fanatic Wisp Corrupted', rarity: 'Common', power: 50, pool: 'standard'},
{ id: 'c76', name: 'Fanatic Wisp Overclocked', rarity: 'Common', power: 50, pool: 'standard' },
{ id: 'c77', name: 'Fanatic Wisp Ultimate', rarity: 'Common', power: 50, pool: 'standard' },
{ id: 'c78', name: 'Void Fanatic', rarity: 'Common', power: 50, pool: 'standard' },
{ id: 'c79', name: 'Cosmic Fanatic', rarity: 'Common', power: 50, pool: 'standard' },
{ id: 'c80', name: 'Temporal Fanatic', rarity: 'Common', power: 50, pool: 'standard' },
{ id: 'c81', name: 'Ethereal Fanatic', rarity: 'Common', power: 50, pool: 'standard' },
{ id: 'c82', name: 'Primal Fanatic', rarity: 'Common', power: 50, pool: 'standard' },
{ id: 'c83', name: 'Abyssal Fanatic', rarity: 'Common', power: 50, pool: 'standard' },
{ id: 'c84', name: 'Radiant Fanatic', rarity: 'Common', power: 50, pool: 'standard' },
{ id: 'c85', name: 'Infernal Fanatic', rarity: 'Common', power: 50, pool: 'standard' },
{ id: 'c86', name: 'Celestial Fanatic', rarity: 'Common', power: 50, pool: 'standard' },
{ id: 'c87', name: 'Eternal Fanatic', rarity: 'Common', power: 50, pool: 'standard' },
{ id: 'c88', name: 'Holo Fanatic', rarity: 'Common', power: 50, pool: 'standard' },
{ id: 'c89', name: 'Neon Fanatic', rarity: 'Common', power: 50, pool: 'standard' },
{ id: 'c90', name: 'Cyber Fanatic', rarity: 'Common', power: 50, pool: 'standard' },
{ id: 'c91', name: 'Pyro Fanatic', rarity: 'Common', power: 50, pool: 'standard' },
{ id: 'c92', name: 'Aqua Fanatic', rarity: 'Common', power: 50, pool: 'standard' },
{ id: 'c93', name: 'Terra Fanatic', rarity: 'Common', power: 50, pool: 'standard' },
{ id: 'c94', name: 'Lunar Fanatic', rarity: 'Common', power: 50, pool: 'standard' },
{ id: 'c95', name: 'Solar Fanatic', rarity: 'Common', power: 50, pool: 'standard' },
{ id: 'c96', name: 'Void Fanatic', rarity: 'Common', power: 50, pool: 'standard' },
// Witch Commons
{ id: 'c97', name: 'Witch Wisp', rarity: 'Common', power: 50, pool: 'standard' },
{ id: 'c98', name: 'Witch Fragment', rarity: 'Common', power: 45, pool: 'standard' },
{ id: 'c99', name: 'Witch Node', rarity: 'Common', power: 40, pool: 'standard' },
{ id: 'c100', name: 'Witch Wisp X', rarity: 'Common', power: 35, pool: 'standard' },
{ id: 'c101', name: 'Witch Wisp Prime', rarity: 'Common', power: 30, pool: 'standard'},
{ id: 'c102', name: 'Witch Wisp Ascended', rarity: 'Common', power: 25, pool: 'standard'},
{ id: 'c103', name: 'Holo Witch', rarity: 'Common', power: 50, pool: 'standard'},
{ id: 'c104', name: 'Neon Witch', rarity: 'Common', power: 50, pool: 'standard' },
{ id: 'c105', name: 'Cyber Witch', rarity: 'Common', power: 50, pool: 'standard' },
{ id: 'c106', name: 'Pyro Witch', rarity: 'Common', power: 50, pool: 'standard' },
{ id: 'c107', name: 'Aqua Witch', rarity: 'Common', power: 50, pool: 'standard' },
{ id: 'c108', name: 'Terra Witch', rarity: 'Common', power: 50, pool: 'standard' },
{ id: 'c109', name: 'Lunar Witch', rarity: 'Common', power: 50, pool: 'standard' },
{ id: 'c110', name: 'Solar Witch', rarity: 'Common', power: 50, pool: 'standard' },
{ id: 'c111', name: 'Void Witch', rarity: 'Common', power: 50, pool: 'standard' },
{ id: 'c112', name: 'Prism Witch', rarity: 'Common', power: 50, pool: 'standard' },
{ id: 'c113', name: 'Radiant Witch', rarity: 'Common', power: 50, pool: 'standard' },
{ id: 'c114', name: 'Infernal Witch', rarity: 'Common', power: 50, pool: 'standard' },
{ id: 'c115', name: 'Celestial Witch', rarity: 'Common', power: 50, pool: 'standard' },
{ id: 'c116', name: 'Eternal Witch', rarity: 'Common', power: 50, pool: 'standard' },
{ id: 'c117', name: 'Shadow Witch', rarity: 'Common', power: 50, pool: 'standard' },
{ id: 'c118', name: 'Light Witch', rarity: 'Common', power: 50, pool: 'standard' },
// Brute Commons
{ id: 'c119', name: 'Brute Wisp', rarity: 'Common', power: 50, pool: 'standard' },
{ id: 'c120', name: 'Brute Fragment', rarity: 'Common', power: 45, pool: 'standard' },
{ id: 'c121', name: 'Brute Node', rarity: 'Common', power: 40, pool: 'standard' },
{ id: 'c122', name: 'Brute Wisp X', rarity: 'Common', power: 35, pool: 'standard' },
{ id: 'c123', name: 'Brute Wisp Prime', rarity: 'Common', power: 30, pool: 'standard'},
{ id: 'c124', name: 'Brute Wisp Ascended', rarity: 'Common', power: 25, pool: 'standard'},
{ id: 'c125', name: 'Holo Brute', rarity: 'Common', power: 50, pool: 'standard'},
{ id: 'c126', name: 'Neon Brute', rarity: 'Common', power: 50, pool: 'standard' },
{ id: 'c127', name: 'Cyber Brute', rarity: 'Common', power: 50, pool: 'standard' },
{ id: 'c128', name: 'Pyro Brute', rarity: 'Common', power: 50, pool: 'standard' },
{ id: 'c129', name: 'Aqua Brute', rarity: 'Common', power: 50, pool: 'standard' },
{ id: 'c130', name: 'Terra Brute', rarity: 'Common', power: 50, pool: 'standard' },
{ id: 'c131', name: 'Lunar Brute', rarity: 'Common', power: 50, pool: 'standard' },
{ id: 'c132', name: 'Solar Brute', rarity: 'Common', power: 50, pool: 'standard' },
{ id: 'c133', name: 'Void Brute', rarity: 'Common', power: 50, pool: 'standard' },
{ id: 'c134', name: 'Prism Brute', rarity: 'Common', power: 50, pool: 'standard' },
{ id: 'c135', name: 'Radiant Brute', rarity: 'Common', power: 50, pool: 'standard' },
{ id: 'c136', name: 'Infernal Brute', rarity: 'Common', power: 50, pool: 'standard' },
{ id: 'c137', name: 'Celestial Brute', rarity: 'Common', power: 50, pool: 'standard' },
{ id: 'c138', name: 'Eternal Brute', rarity: 'Common', power: 50, pool: 'standard' },
{ id: 'c139', name: 'Shadow Brute', rarity: 'Common', power: 50, pool: 'standard' },
{ id: 'c140', name: 'Light Brute', rarity: 'Common', power: 50, pool: 'standard' },

];